import React from "react";

const TEXT = [["name", "Event name", "e.g. ITB Berlin 2027"], ["organiser", "Organiser", "e.g. Messe Berlin"], ["city", "City", "e.g. Berlin"],
  ["country", "Country", "e.g. Germany"], ["venue", "Venue", "e.g. Messe Berlin"]];

function Tag({ prov, c }) {
  if (!prov) return <span className={`px-1.5 py-0.5 rounded-full text-[9px] category-tag ${c.tagUser}`} data-testid="prov-missing">MISSING</span>;
  return <span className={`px-1.5 py-0.5 rounded-full text-[9px] category-tag ${prov === "page" ? c.tagPage : c.tagUser}`}>{prov === "page" ? "FROM THE PAGE" : "PROVIDED BY YOU"}</span>;
}

function Field({ k, label, empty, prov, c, children }) {
  return (
    <label className="block" data-testid={`proposal-field-${k}`}>
      <span className={`flex items-center justify-between gap-2 mb-1 text-[11px] font-semibold ${c.muted}`}>{label} <Tag prov={empty ? "" : prov} c={c} /></span>
      {children}
    </label>
  );
}

/** Required proposal fields: found ones pre-filled (editable), missing ones highlighted. */
export function ProposalFields({ fields, prov, setField, taxonomy, c }) {
  const tax = taxonomy || { types: {}, access: {}, themes: {} };
  const cls = (k) => `w-full h-10 rounded-lg border px-3 text-sm outline-none focus:ring-2 focus:ring-[#006874]/30 ${fields[k] && !(Array.isArray(fields[k]) && !fields[k].length) ? c.input : c.inputMissing}`;
  const isEmpty = (k) => (Array.isArray(fields[k]) ? fields[k].length === 0 : !fields[k]);
  return (
    <div className="mt-4 grid gap-3 sm:grid-cols-2">
      {TEXT.map(([k, label, ph]) => (
        <Field key={k} k={k} label={label} empty={isEmpty(k)} prov={prov[k]} c={c}>
          <input value={fields[k] || ""} onChange={(e) => setField(k, e.target.value)} placeholder={ph} required data-testid={`proposal-input-${k}`} className={cls(k)} />
        </Field>
      ))}
      <div className="grid grid-cols-2 gap-3">
        <Field k="start_date" label="Start date" empty={isEmpty("start_date")} prov={prov.start_date} c={c}>
          <input type="date" value={fields.start_date || ""} onChange={(e) => { setField("start_date", e.target.value); if (!fields.end_date || fields.end_date < e.target.value) setField("end_date", e.target.value); }} required data-testid="proposal-input-start_date" className={cls("start_date")} />
        </Field>
        <Field k="end_date" label="End date" empty={isEmpty("end_date")} prov={prov.end_date} c={c}>
          <input type="date" value={fields.end_date || ""} min={fields.start_date || undefined} onChange={(e) => setField("end_date", e.target.value)} required data-testid="proposal-input-end_date" className={cls("end_date")} />
        </Field>
      </div>
      <Field k="event_type" label="Type" empty={isEmpty("event_type")} prov={prov.event_type} c={c}>
        <select value={fields.event_type || ""} onChange={(e) => setField("event_type", e.target.value)} required data-testid="proposal-input-event_type" className={cls("event_type")}>
          <option value="">Choose…</option>{Object.entries(tax.types || {}).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </Field>
      <Field k="access" label="Access" empty={isEmpty("access")} prov={prov.access} c={c}>
        <select value={fields.access || ""} onChange={(e) => setField("access", e.target.value)} required data-testid="proposal-input-access" className={cls("access")}>
          <option value="">Choose…</option>{Object.entries(tax.access || {}).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </Field>
      <div className="sm:col-span-2" data-testid="proposal-field-themes">
        <span className={`flex items-center justify-between gap-2 mb-1.5 text-[11px] font-semibold ${c.muted}`}>Themes (at least one) <Tag prov={isEmpty("themes") ? "" : prov.themes} c={c} /></span>
        <div className="flex flex-wrap gap-1.5">
          {Object.entries(tax.themes || {}).map(([k, v]) => {
            const on = (fields.themes || []).includes(k);
            return (
              <button type="button" key={k} onClick={() => setField("themes", on ? fields.themes.filter((t) => t !== k) : [...(fields.themes || []), k])} data-testid={`proposal-theme-${k}`} aria-pressed={on}
                className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${on ? c.btn : c.btn2}`}>{v}</button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
